"use client";

import { c as _c } from "react/compiler-runtime";
import { BottomSheet, BottomSheetBody, BottomSheetFooter, BottomSheetHeader, BottomSheetHeaderTitle, FlexColumn, FlexEnd, FormControl, formatAddress, Input, Media, Popover, Separator, Spinner, TextLabel } from "@opensea/ui-kit";
import { useState } from "react";
import { useFormContext, useFormState, useWatch } from "react-hook-form";
import { useTranslations } from "use-intl";
import { Button } from "../../../../../components/Button";
import { useAddressInputField } from "../../../../../hooks/useAddressInput";
export const ReserveButton = () => {
  const $ = _c(74);
  const t = useTranslations("wallet.ReserveButton");
  const [isOpen, setIsOpen] = useState(false);
  const {
    control,
    setValue,
    register
  } = useFormContext();
  let t0;
  if ($[0] !== control) {
    t0 = {
      control
    };
    $[0] = control;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const {
    errors
  } = useFormState(t0);
  let t1;
  if ($[2] !== control) {
    t1 = {
      control,
      name: "reservedBuyer"
    };
    $[2] = control;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const reservedBuyer = useWatch(t1);
  let t2;
  if ($[4] !== reservedBuyer.identifier || $[5] !== setValue) {
    t2 = {
      field: "reservedBuyer",
      setValue,
      identifier: reservedBuyer.identifier
    };
    $[4] = reservedBuyer.identifier;
    $[5] = setValue;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  useAddressInputField(t2);
  const error = reservedBuyer.isResolving ? undefined : errors.reservedBuyer?.identifier?.message ?? errors.reservedBuyer?.resolvedAddress?.message;
  const t3 = error ? "!border-error-1" : "";
  let t4;
  if ($[7] !== t) {
    t4 = t("reserve");
    $[7] = t;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t3 || $[10] !== t4) {
    t5 = <Button className={t3} size="sm" variant="secondary">{t4}</Button>;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const trigger = t5;
  let t6;
  if ($[12] !== t) {
    t6 = t("reserveForBuyer");
    $[12] = t;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== reservedBuyer.isResolving) {
    t7 = reservedBuyer.isResolving ? <Spinner color="text-secondary" size="2xs" /> : undefined;
    $[14] = reservedBuyer.isResolving;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t) {
    t8 = t("enterRecipientAddress");
    $[16] = t;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== register) {
    t9 = register("reservedBuyer.identifier");
    $[18] = register;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t7 || $[21] !== t8 || $[22] !== t9) {
    t10 = <Input autoFocus={true} endEnhancer={t7} placeholder={t8} size="sm" {...t9} />;
    $[20] = t7;
    $[21] = t8;
    $[22] = t9;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== error || $[25] !== t10 || $[26] !== t6) {
    t11 = <FormControl error={error} hideLabel={true} label={t6}>{t10}</FormControl>;
    $[24] = error;
    $[25] = t10;
    $[26] = t6;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  let t12;
  if ($[28] !== reservedBuyer.resolvedAddress) {
    t12 = reservedBuyer.resolvedAddress && <FlexEnd><TextLabel size="xs">{formatAddress(reservedBuyer.resolvedAddress)}</TextLabel></FlexEnd>;
    $[28] = reservedBuyer.resolvedAddress;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  let t13;
  if ($[30] !== t11 || $[31] !== t12) {
    t13 = <FlexColumn className="gap-1">{t11}{t12}</FlexColumn>;
    $[30] = t11;
    $[31] = t12;
    $[32] = t13;
  } else {
    t13 = $[32];
  }
  const addressInput = t13;
  let t14;
  if ($[33] !== t) {
    t14 = t("reserve");
    $[33] = t;
    $[34] = t14;
  } else {
    t14 = $[34];
  }
  let t15;
  if ($[35] !== t14) {
    t15 = <BottomSheetHeader><BottomSheetHeaderTitle>{t14}</BottomSheetHeaderTitle></BottomSheetHeader>;
    $[35] = t14;
    $[36] = t15;
  } else {
    t15 = $[36];
  }
  let t16;
  if ($[37] !== t) {
    t16 = t("reserveForBuyer");
    $[37] = t;
    $[38] = t16;
  } else {
    t16 = $[38];
  }
  let t17;
  if ($[39] !== t16) {
    t17 = <TextLabel color="text-secondary" size="2xs">{t16}</TextLabel>;
    $[39] = t16;
    $[40] = t17;
  } else {
    t17 = $[40];
  }
  let t18;
  if ($[41] !== addressInput || $[42] !== t17) {
    t18 = <FlexColumn className="grow gap-3">{t17}{addressInput}</FlexColumn>;
    $[41] = addressInput;
    $[42] = t17;
    $[43] = t18;
  } else {
    t18 = $[43];
  }
  let t19;
  if ($[44] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <Separator className="h-auto flex-none" orientation="vertical" />;
    $[44] = t19;
  } else {
    t19 = $[44];
  }
  let t20;
  if ($[45] !== t18) {
    t20 = <BottomSheetBody><FlexColumn className="gap-3">{t18}{t19}</FlexColumn></BottomSheetBody>;
    $[45] = t18;
    $[46] = t20;
  } else {
    t20 = $[46];
  }
  let t21;
  if ($[47] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = () => setIsOpen(false);
    $[47] = t21;
  } else {
    t21 = $[47];
  }
  let t22;
  if ($[48] !== t) {
    t22 = t("confirm");
    $[48] = t;
    $[49] = t22;
  } else {
    t22 = $[49];
  }
  let t23;
  if ($[50] !== t22) {
    t23 = <BottomSheetFooter><Button onClick={t21} size="sm">{t22}</Button></BottomSheetFooter>;
    $[50] = t22;
    $[51] = t23;
  } else {
    t23 = $[51];
  }
  let t24;
  if ($[52] !== t15 || $[53] !== t20 || $[54] !== t23) {
    t24 = <>{t15}{t20}{t23}</>;
    $[52] = t15;
    $[53] = t20;
    $[54] = t23;
    $[55] = t24;
  } else {
    t24 = $[55];
  }
  let t25;
  if ($[56] !== isOpen || $[57] !== t24 || $[58] !== trigger) {
    t25 = <Media lessThan="md"><BottomSheet content={t24} nested={true} onOpenChange={setIsOpen} open={isOpen}>{trigger}</BottomSheet></Media>;
    $[56] = isOpen;
    $[57] = t24;
    $[58] = trigger;
    $[59] = t25;
  } else {
    t25 = $[59];
  }
  let t26;
  if ($[60] !== t) {
    t26 = t("reserveForBuyer");
    $[60] = t;
    $[61] = t26;
  } else {
    t26 = $[61];
  }
  let t27;
  if ($[62] !== t26) {
    t27 = <TextLabel color="text-secondary" size="2xs">{t26}</TextLabel>;
    $[62] = t26;
    $[63] = t27;
  } else {
    t27 = $[63];
  }
  let t28;
  if ($[64] !== addressInput || $[65] !== t27) {
    t28 = <FlexColumn className="gap-3">{t27}{addressInput}</FlexColumn>;
    $[64] = addressInput;
    $[65] = t27;
    $[66] = t28;
  } else {
    t28 = $[66];
  }
  let t29;
  if ($[67] !== isOpen || $[68] !== t28 || $[69] !== trigger) {
    t29 = <Media greaterThanOrEqual="md"><Popover className="w-[400px] bg-bg-primary" content={t28} onOpenChange={setIsOpen} open={isOpen} portal={false}>{trigger}</Popover></Media>;
    $[67] = isOpen;
    $[68] = t28;
    $[69] = trigger;
    $[70] = t29;
  } else {
    t29 = $[70];
  }
  let t30;
  if ($[71] !== t25 || $[72] !== t29) {
    t30 = <>{t25}{t29}</>;
    $[71] = t25;
    $[72] = t29;
    $[73] = t30;
  } else {
    t30 = $[73];
  }
  return t30;
};